import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier } from "../modifiers/index.js";
export const Table = ({ children, className, isHoverable, isFullwidth, isNarrow, isBordered, isStriped, withContainer, ...props }) => {
    const containerClassName = withContainer ? "table-container" : undefined;
    const _class = classNames("table", modifier({ isBordered, isFullwidth, isHoverable, isNarrow, isStriped }), className);
    return (_jsx("div", { className: containerClassName, children: _jsx("table", { className: _class, ...props, children: children }) }));
};
